<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-27 10:27:11
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div class="modelTitle" style="margin-top: 30px">任务信息</div>
        <div class="modelDetail">
          <div class="infoItem">任务名称：{{ detail.jobTitle }}</div>
          <div class="infoItem">客户名称：{{ detail.customName }}</div>
          <div class="infoItem">创建时间：{{ detail.callAt }}</div>
          <div class="infoItem">完成时间：{{ detail.wantCallAt }}</div>
          <div class="infoItem">负责回访人：{{ detail.nickname }}</div>
          <div class="infoItem">
            回访状态：{{
              detail.status == 0
                ? "未完成"
                : detail.status == 1
                ? "回访中"
                : "已完成"
            }}
          </div>
        </div>
        <div class="modelTitle" style="margin-top: 30px">记录列表</div>
        <div style="margin-top: 30px">
          <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane label="回访记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="id" label="编号" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="回访人" align="center">
                </el-table-column>
                <el-table-column
                  prop="wantCallAt"
                  label="回访时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="回访内容" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.memo }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="回访状态" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.memo }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, prev, pager, next,sizes"
                :total="total"
              >
              </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      editId: "",
      tableData: [],
      age: 0,
      year: 0,
      detail: {},
      pageSize: 10,
      page: 1,
      total: 0,
      selectIndex: 0, //记录列表选中的下标
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail1();
      this.getlist();
    }
    this.year = new Date().getFullYear();
  },
  methods: {
    getDetail1() {
      this.$axios
        .post(`/admapi/followup/get/${this.editId}`, { customId: this.editId })
        .then(({ data }) => {
          this.detail = data;
        })
        .catch()
        .finally();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getlist() {
      this.$axios
        .post(`/admapi/followup/recordlist/${this.editId}`)
        .then(({ data }) => {
          console.log(data);
          this.tableData = data;
        })
        .catch()
        .finally();
    },
    handleClick(tab) {
      this.selectIndex = tab.index;
      this.pageSize = 10;
      this.page = 1;
      this.getlist();
    },
  },
};
</script>
<style scoped>
.modelTitle {
  border-left: solid 5px #165dff;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 22px;
  font-weight: 600;
}
.modelDetail {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;
}
.infoItem {
  margin-right: 80px;
  color: #6d6b6b;
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.infoItem img {
  width: 300px;
  height: 200px;
  margin-left: 20px;
}
</style>
